import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import Popup from 'components/popups/Popup'
import { QrReader } from 'react-qr-reader'
import React from 'react'

interface ScannerPopupProps {

}

const ScannerPopup: React.FC<ScannerPopupProps> = () => {
  const { t } = useTranslation('shop')
  return (
    <Popup centered>
      <div className='scanner__popup'>
        <div className='popup__title'>
          <div>{t('scanner')}</div>
        </div>
        <QrReader
          constraints={{
            facingMode: 'environment'
          }}
          onResult={console.log}
          containerStyle={{
            width: '100%'
          }}
        />
        <BackBtn />
      </div>
    </Popup>
  )
}

export default ScannerPopup